<template>
    <div
        v-can.hide="'playbooks:create'"
        class="c-playbook-add"
        @click.stop.prevent="onShowClick"
    >
        <slot name="trigger"></slot>
        <Modal
            v-model="modalActive"
            :title="'New Playbook'"
            :footer-hide="true"
            label-position="top"
            @on-visible-change="handleVisibleChange"
            class-name="vertical-center-modal "
        >
            <Form
                ref="formData"
                :model="formData"
                :rules="validationRules"
                v-on:submit.native.prevent="handleSubmit"
            >
                <FormItem label="Name" prop="name">
                    <Input
                        v-focus
                        v-model="formData.name"
                        placeholder="Give your playbook a name"
                    ></Input>
                </FormItem>

                <FormItem
                    label="Apply to Accounts or Contacts"
                    prop="entityTypeId"
                    class="mt-7"
                >
                    <br />
                    <RadioGroup v-model="formData.entityTypeId" type="button">
                        <Radio label="1">Accounts</Radio>
                        <Radio label="2">Contacts</Radio>
                    </RadioGroup>
                </FormItem>

                <FormItem class="mt-7">
                    <Button
                        type="text"
                        :disabled="isSaving"
                        :class="[
                            isSaving ? 'text-muted' : 'text-secondary',
                            'p-0',
                        ]"
                        @click="handleCancel"
                        >Cancel</Button
                    >
                    <Button
                        ref="saveAndClose"
                        :loading="isSaving"
                        type="primary"
                        @click="handleSubmit"
                        class="float-right ml-2"
                        >Save</Button
                    >
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
import focus from "@/js/directives/focus-input";
export default {
    props: {
        playbooksRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/base.js"))(
                    window.akita.urls.api + "/v1/playbooks"
                );
            },
        },
    },
    data() {
        return {
            isSaving: false,
            modalActive: false,
            formData: {
                name: "",
                entityTypeId: 1,
            },
            validationRules: {
                name: [
                    {
                        required: true,
                        message: "Playbook name cannot be empty",
                        trigger: "blur",
                    },
                ],
                entityTypeId: [
                    {
                        required: true,
                        message: 'Select "Account" or "Contact"?',
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    computed: {},
    watch: {},
    methods: {
        handleVisibleChange(isModalVisible) {
            if (!isModalVisible) this.formData.playbookName = null;
            this.$refs["formData"].resetFields();
        },
        onShowClick() {
            this.modalActive = true;
        },
        handleCancel() {
            this.modalActive = false;
        },
        handleSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) this.handleSave();
            });
        },
        async handleSave() {
            this.isSaving = true;

            let request = {
                params: {},
            };

            let payload = {
                entity_type_id: parseInt(this.formData.entityTypeId),
                name: this.formData.name,
            };

            try {
                let response = await this.playbooksRepository.store(
                    payload,
                    request
                );

                let playbook = response.data.data;

                this.$Message.success({
                    content: "New playbook added.",
                });

                this.isSaving = false;

                this.$refs["formData"].resetFields();

                this.modalActive = false;

                this.$router.push({
                    path: "/playbooks/" + playbook.id + "/edit",
                });
            } catch (err) {
                this.isSaving = false;
                throw err;
            }
        },
    },
    directives: {
        focus: focus,
    },
};
</script>
